// ZoomWrapper.tsx
import React, { createContext, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useBreakpoint } from "shared/hooks/useBreakpoint";

const ZoomScrollContext = createContext<React.RefObject<HTMLDivElement> | null>(
  null,
);

export const useZoomScrollContainer = () => useContext(ZoomScrollContext);

interface ZoomWrapperProps {
  children: React.ReactNode;
}

export const ZoomWrapper: React.FC<ZoomWrapperProps> = ({ children }) => {
  const location = useLocation();
  const breakpoint = useBreakpoint();
  const isMobile =
    breakpoint !== "xxl" && breakpoint !== "xl" && breakpoint !== "lg";
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const scale = 0.8;

  if (location.pathname === "/redirect") {
    return <>{children}</>;
  }

  if (isMobile) {
    return <>{children}</>;
  }

  return (
    <ZoomScrollContext.Provider value={scrollContainerRef}>
      <div
        ref={scrollContainerRef}
        style={{
          position: "fixed",
          inset: 0,
          overflow: "auto",
          overflowX: "hidden",
        }}
      >
        <div
          style={{
            transform: `scale(${scale})`,
            transformOrigin: "top left",
            width: `${100 / scale}%`,
            height: `${100 / scale}%`,
          }}
        >
          {children}
        </div>
      </div>
    </ZoomScrollContext.Provider>
  );
};
